import { useEffect, useRef } from 'react';
import { sessionApi } from '../services/api';

const HEARTBEAT_INTERVAL = 30000; // 30 seconds

export const useSession = () => {
  const intervalRef = useRef(null);

  const getEmployeeId = () => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      return user?.id || null;
    } catch {
      return null;
    }
  };

  const startHeartbeat = () => {
    const empId = getEmployeeId();
    if (!empId) return;

    // Pehle ek heartbeat turant bhejo
    sessionApi.heartbeat(empId).catch(console.error);

    // Phir har 30 sec mein
    intervalRef.current = setInterval(() => {
      const id = getEmployeeId();
      if (id) {
        sessionApi.heartbeat(id).catch(console.error);
      }
    }, HEARTBEAT_INTERVAL);
  };

  const stopHeartbeat = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  useEffect(() => {
    // App open hone pe start
    startHeartbeat();

    // Tab visibility change handle karo
    const handleVisibilityChange = () => {
      if (document.hidden) {
        stopHeartbeat(); // Tab hidden → band karo
      } else {
        startHeartbeat(); // Tab visible → phir shuru karo
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      stopHeartbeat();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
};